import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { StartupPointsResponse } from "../types";
export function useStartupPoints(options) {
  const $ = _c(6);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = () => apiFetcher("/api/v1/sessions/startup-points");
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = options?.enabled ?? true;
  const t2 = options?.staleTime ?? 3600000;
  let t3;
  if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2) {
    t3 = {
      queryKey: QUERY_KEYS.STARTUP_POINTS,
      queryFn: t0,
      enabled: t1,
      staleTime: t2,
      gcTime: 3600000
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return useQuery(t3);
}